export default __webpack_public_path__ + "static/media/OldCoin.6409cdb3.JPG";